import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Log environment variables for debugging
console.log('Supabase URL:', supabaseUrl ? '✓ Present' : '✗ Missing');
console.log('Supabase Anon Key:', supabaseAnonKey ? '✓ Present' : '✗ Missing');

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Authentication will not work.');
}

export const supabase = createClient<Database>(
  supabaseUrl || 'https://placeholder-url.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
      flowType: 'pkce',
      debug: import.meta.env.DEV, // Only enable debug in development
      retryAttempts: 3,
      retryInterval: 2000,
      storageKey: 'advisorgrow.auth.token',
      cookieOptions: {
        name: 'advisorgrow-auth',
        lifetime: 60 * 60 * 8, // 8 hours
        domain: window.location.hostname,
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:'
      }
    },
    global: {
      headers: {
        'X-Client-Info': 'advisorgrow-web'
      }
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  }
);

// Export a function to check connection status
export async function checkSupabaseConnection() {
  try {
    const { data, error } = await supabase.from('users').select('count').limit(1);
    return { success: !error, error, data };
  } catch (err) {
    console.error('Supabase connection check failed:', err);
    return { success: false, error: err };
  }
}

// Function to get current session
export async function getCurrentSession() {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data.session;
  } catch (error) {
    console.error('Error getting current session:', error);
    return null;
  }
}

// Function to refresh session
export async function refreshSession() {
  try {
    const { data, error } = await supabase.auth.refreshSession();
    if (error) throw error;
    return data.session;
  } catch (error) {
    console.error('Error refreshing session:', error);
    return null;
  }
}